export interface QuestionnaireQuestionCopy {
    submitLabel: string
}

export interface QuestionnaireOffRampCopy {
    continueLabel: string
    secondaryLabel: string
    showAvailability: boolean
    showSoonestAppointment: boolean
    icon: 'warning' | 'info'
    titleOrder: 1 | 2
}

/** Screen-specific copy for the unable-to-treat off-ramp interstitial. */
export interface QuestionnaireUnableToTreatCopy {
    title: string
    body: string
    /** Contact CTA label. Empty hides the button. */
    secondaryLabel: string
}

export interface QuestionnaireCopy {
    question: QuestionnaireQuestionCopy
    offRamp: QuestionnaireOffRampCopy
    unableToTreat: QuestionnaireUnableToTreatCopy
}

export const generalMedicineQuestionnaireCopy: QuestionnaireCopy = {
    question: {
        submitLabel: 'Next',
    },
    offRamp: {
        continueLabel: 'Continue',
        secondaryLabel: 'Text our care team',
        showAvailability: true,
        showSoonestAppointment: true,
        icon: 'warning',
        titleOrder: 2,
    },
    unableToTreat: {
        title: 'We may not be able to treat you virtually',
        body: "Based on your responses, you may need in-person care that can't be done virtually. Please text us so we can guide you to the right option.",
        secondaryLabel: 'Text us',
    },
}
